import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { FormField } from '@cp/ds/src/components/form';
import { useFormContext, useWatch } from 'react-hook-form';
import { Button } from '@cp/ds/src/components/button';
import { VacancyCreateRequestChildren } from '@common/model/catalog/item/vacancyCreate.request';
import { Box } from '@cp/ds/src/components/box';
import { CHILD_AGE_DEFAULT, FormModel, useChildAgeSelectItems } from '../../../model';
import { ChildrenProps } from './model';

export const Children: React.FC<ChildrenProps> = () => {
  const form = useFormContext<FormModel>();
  const items = useChildAgeSelectItems();

  // Reason to use 'useWatch' and 'getValues' together:
  // https://github.com/react-hook-form/react-hook-form/issues/2738
  useWatch<FormModel, 'children'>({ name: 'children' });
  const children: VacancyCreateRequestChildren[] = form.getValues('children') ?? [];

  const handleAdd = () => {
    form.setValue('children', [...children, { age: CHILD_AGE_DEFAULT }]);
  };

  return (
    <Stack direction="column" gap={2.5}>
      {children.map((_, index) => (
        <Box key={index}>
          <FormField
            fieldContainerProps={{ sx: { width: 1 } }}
            fieldLabel="Возраст ребенка"
            items={items}
            name={`children.${index}.age`}
            placeholder="Выберите"
            sx={{ width: 1 }}
            type="select"
          />
          {index === children.length - 1 && (
            <Button color="pink" onClick={handleAdd} size="small" sx={{ mt: 1.5 }} variant="text">
              Добавить ребенка
            </Button>
          )}
        </Box>
      ))}
    </Stack>
  );
};
